import {
  GroupActionFunctionParameters,
  OverflowMenuGroupActionFunction,
  ToolbarButtonGroupActionFunction,
} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {OverflowMenuOption} from 'ui-library/menus/OverflowMenu';

export interface MakeCustomGroupButtonActionFunctionParams<TTableMetadata, TCreateGroupExtras> {
  // Return whether the button should be hidden completely.
  getHidden?: (params: GroupActionFunctionParameters<TTableMetadata, TCreateGroupExtras>) => boolean;

  // Component to render as the action button
  renderToolbarButton: (
    actionFunctionParams: GroupActionFunctionParameters<TTableMetadata, TCreateGroupExtras>
  ) => JSX.Element;

  // Component to render as the menu item in the overflow menu
  renderOverflowMenuItem: (
    actionFunctionParams: GroupActionFunctionParameters<TTableMetadata, TCreateGroupExtras>
  ) => OverflowMenuOption;
}

/**
 * Create an ActionFunction that can be placed in either the toolbar or the overflow menu.
 */
export default function makeCustomGroupButtonActionFunction<TTableMetadata, TCreateGroupExtras>({
  getHidden,
  renderToolbarButton,
  renderOverflowMenuItem,
}: MakeCustomGroupButtonActionFunctionParams<
  TTableMetadata,
  TCreateGroupExtras
>): ToolbarButtonGroupActionFunction<TTableMetadata, TCreateGroupExtras> &
  OverflowMenuGroupActionFunction<TTableMetadata, TCreateGroupExtras> {
  return {
    renderToolbarButton: (params) => {
      if (getHidden?.(params)) {
        return null;
      }
      return renderToolbarButton(params);
    },

    getOverflowMenuItem: (params) => {
      if (getHidden?.(params)) {
        return null;
      }
      return renderOverflowMenuItem(params);
    },
  };
}
